import styles from './styles.less';


// Module
import routes from './routes';

export default angular.module('app.main.addToAccount.module', [])
	.config(routes)
	.name



/** WEBPACK FOOTER **
 ** ./src/main/panels/addToAccount/index.js
 **/